"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3325],{

/***/ 3325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GarageProfileOpeninghours": function() { return /* binding */ GarageProfileOpeninghours; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _eo_locale_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7245);



var GarageProfileOpeninghours = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(param) {
    var garage = param.garage;
    var ref;
    var days = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday"
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "garageProfile_openinghours col-span-full mb-6 md:mb-8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "text-lg font-serif mb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                    id: "profileDetails_opening_hours"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                className: "openingHoursList",
                children: (ref = garage.opening_hours) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                        className: "".concat(item.open === "geschlossen" ? "closed" : "open", "  flex items-center h-6 py-2"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                                        id: "profileDetails_days_".concat(days[item.day - 1])
                                    }),
                                    "\xa0"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "w-full text-right",
                                children: item.open
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
});
GarageProfileOpeninghours.displayName = "GarageProfileOpeninghours";


/***/ })

}]);